const qualificationStatuses = {
    QUALIFIED: 'QUALIFIED',
    HAS_PENDING_TASKS: 'HAS_PENDING_TASKS',
};

export default qualificationStatuses;
